import { Action } from 'redux';
import { ErrorResponse } from 'core/http/response';
import { InvoiceConfig } from './types';

export enum InvoiceConfigActions {
    GET_INVOICE_CONFIG_REQUEST = 'GET_INVOICE_CONFIG_REQUEST',
    GET_INVOICE_CONFIG_SUCCESS = 'GET_INVOICE_CONFIG_SUCCESS',
    GET_INVOICE_CONFIG_ERROR = 'GET_INVOICE_CONFIG_ERROR',
    UPDATE_INVOICE_CONFIG_REQUEST = 'UPDATE_INVOICE_CONFIG_REQUEST',
    UPDATE_INVOICE_CONFIG_SUCCESS = 'UPDATE_INVOICE_CONFIG_SUCCESS',
    UPDATE_INVOICE_CONFIG_ERROR = 'UPDATE_INVOICE_CONFIG_ERROR',
}

export interface GET_INVOICE_CONFIG_REQUEST extends Action {
    type: InvoiceConfigActions.GET_INVOICE_CONFIG_REQUEST;
}
export interface GET_INVOICE_CONFIG_SUCCESS extends Action {
    type: InvoiceConfigActions.GET_INVOICE_CONFIG_SUCCESS;
    payload: InvoiceConfig;
}
export interface GET_INVOICE_CONFIG_ERROR extends Action {
    type: InvoiceConfigActions.GET_INVOICE_CONFIG_ERROR;
    error: ErrorResponse;
}

export interface UPDATE_INVOICE_CONFIG_REQUEST extends Action {
    type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_REQUEST;
}
export interface UPDATE_INVOICE_CONFIG_SUCCESS extends Action {
    type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_SUCCESS;
    payload: InvoiceConfig;
}
export interface UPDATE_INVOICE_CONFIG_ERROR extends Action {
    type: InvoiceConfigActions.UPDATE_INVOICE_CONFIG_ERROR;
    error: ErrorResponse;
}

export type InvoiceConfigActionTypes =
    | GET_INVOICE_CONFIG_REQUEST
    | GET_INVOICE_CONFIG_SUCCESS
    | GET_INVOICE_CONFIG_ERROR
    | UPDATE_INVOICE_CONFIG_REQUEST
    | UPDATE_INVOICE_CONFIG_SUCCESS
    | UPDATE_INVOICE_CONFIG_ERROR;
